import { Injectable } from '@angular/core';
import { DataService, QueryParameter } from '@barthauer/abc/core/data';
import { EditorInstanceSettings } from 'libs/abc/ui-components/src/lib/core/src/abc-grid/abc-grid';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EditorService {
  public editorIndex: number = 0;
  public editorInstances: EditorInstanceSettings[] = [];

  constructor(private coreDataService: DataService) {}

  public setValue(queryValue: QueryParameter): void {
    this.coreDataService.executeSetValueQuery(queryValue).subscribe();
  }

  public getValue(queryValue: QueryParameter): Observable<any> {
    return this.coreDataService.executeGetValueQuery(queryValue);
  }
}
